import React from 'react';
//import DataGrid from 'devextreme-react/data-grid';
import DataGrid, { Column, FilterRow, HeaderFilter, SearchPanel,Paging,Pager  } from 'devextreme-react/data-grid';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";

import { plans } from '../../data_files/PlansData';
import plusimg from '../../images/common/plus.png'
import exportimg from '../../images/common/xlsx.png'

import history from "../history";
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const columns = ['ins_status'
,'ins_local_client'
,'ins_plan_owner'
,'ins_media'
,'ins_sub_media'
,'ins_mar_level1'
,'ins_mar_level5'
,'ins_campaign'
,'ins_vehicle'
,'ins_start_date'
,'ins_end_date'
,'ins_currency'
,'ins_cost'
,'ins_fees'
,'ins_net_net_cost'];
  // 'ins_status', 'Client', 'Plan Owner',
  //               'Media', 'SubMedia', 'Fees',
  //               'M. Level1','M. Level 5','Campaign',
  //               'Vehicle','Start Date', 'End Date',
  //               'Currency','Net Cost','Fees','Net Net Cost'];

const url = "http://localhost:86";

const dataSource = createStore({
  key: "ins_id",
  loadUrl: `${url}/InsertionMicroservice`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/InsertionMicroservice`, ///DeleteOrder
  onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        'accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});
                
  const CreateNewPlan = () =>{
    history.push('/admin/planpage') ;
  }
class Insertitionpoc extends React.Component {
    constructor(props) {
        super(props);
        
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];
        this.saleAmountHeaderFilter = [{
          text: 'Less than $3000',
          value: ['SaleAmount', '<', 3000]
        }, {
          text: '$3000 - $5000',
          value: [
            ['SaleAmount', '>=', 3000],
            ['SaleAmount', '<', 5000]
          ]
        }, {
          text: '$5000 - $10000',
          value: [
            ['SaleAmount', '>=', 5000],
            ['SaleAmount', '<', 10000]
          ]
        }, {
          text: '$10000 - $20000',
          value: [
            ['SaleAmount', '>=', 10000],
            ['SaleAmount', '<', 20000]
          ]
        }, {
          text: 'Greater than $20000',
          value: ['SaleAmount', '>=', 20000]
        }];
        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true
        };
        this.dataGrid = null;
       // this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
      }
  render() {
    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>
            Plans Management
          </span>
        </div>
        <div className="div-section-actions push">
          <button  className="btn-section-header">
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header" onClick={() => CreateNewPlan()}>
              <img className="img-section-header" src={plusimg} />
              <label>New Plan</label>
          </button>
        </div>
        </div>
        <div  className="div-padding-20">
      <DataGrid
        dataSource={dataSource}
        keyExpr="ID"
        defaultColumns={columns}
        showBorders={false} 
        showColumnLines={false}
        showRowLines={false}
        rowAlternationEnabled={this.state.rowAlternationEnabled}       
      > 
      <Pager
          visible={true}
          displayMode={"full"}
          showPageSizeSelector={true}
          showInfo={true}
          showNavigationButtons={true} 
          allowedPageSizes={[5,10,20,30,40,50]}
        />
        <Paging defaultPageSize={30}/>
      <FilterRow visible={this.state.showFilterRow} applyFilter={this.state.currentFilter} />
      <HeaderFilter visible={this.state.showHeaderFilter} />

      </DataGrid>
      </div>
      </div>
    );
  }
  onShowFilterRowChanged(e) {
    this.setState({
      showFilterRow: e.value
    });
    this.clearFilter();
  }
  onShowHeaderFilterChanged(e) {
    this.setState({
      showHeaderFilter: e.value
    });
    this.clearFilter();
  }
  onCurrentFilterChanged(e) {
    this.setState({
      currentFilter: e.value
    });
  }
  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }
}


export default Insertitionpoc;
